import { render, staticRenderFns } from "./FetchingLoader.vue?vue&type=template&id=20f4c4d2&scoped=true&"
import script from "./FetchingLoader.vue?vue&type=script&lang=js&"
export * from "./FetchingLoader.vue?vue&type=script&lang=js&"
import style0 from "./FetchingLoader.vue?vue&type=style&index=0&id=20f4c4d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f4c4d2",
  null
  
)

export default component.exports